import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dedupeCount',
})
export class DedupeCountPipe implements PipeTransform {
  // Labs send one value per specimen, comma-joined ("FINAL REPORT,FINAL REPORT,...").
  transform(value: string): string {
    if (!value) {
      return value;
    }
    const counts = new Map<string, number>();
    value
      .split(',')
      .map(s => s.trim())
      .filter(s => s.length > 0)
      .forEach(s => counts.set(s, (counts.get(s) || 0) + 1));
    return Array.from(counts.entries())
      .map(([item, count]) => (count > 1 ? `${item} (${count})` : item))
      .join(', ');
  }
}
